<div class="isg-full-page-header">

  <div class="isg-page-header isg-toolbar">

    <a routerLink="/admin/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-table" title="Back to licenses"></span>
    </a>

    <a routerLink="/admin/user/license"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-user" title="License Users"></span>
    </a>

    <a routerLink="/admin/user/permission"
       [queryParams]="{ id: currentLicenseId }"
       class="isg-button-nav">
      <span class="fas fa-user-shield" title="User Permissions"></span>
    </a>

    <span>Role Management for {{companyName}}</span>
  </div>

  <div class="isg-page-body">

    <div class="isg-role-page"
         [class.isg-module-hide]="hideModule"
         [class.isg-datatree-hide]="hideAuthDataTree">

      <div class="isg-role-cell" [class.isg-cell-hide]="hideModule">

        <div class="isg-subheader">
          <span>Modules</span>
        </div>

        <div class="isg-role-pane" isgSizer #modulePane="isgSizer">
          <app-modules-list [licenseId]="currentLicenseId"
                            [includeHost]="true"
                            [heightControl]="modulePane.height()"
                            (selected)="onModuleSelected($event)"
                            (dataLoaded)="onModulesLoaded($event)">
          </app-modules-list>
        </div>

      </div>

      <div class="isg-role-cell">

        <div class="isg-subheader">
          <span>Roles </span>
        </div>

        <div class="isg-role-pane" isgSizer #rolePane="isgSizer">
          <app-roles-list [moduleId]="currentModuleId"
                          [licenseId]="currentLicenseId"
                          [heightControl]="rolePane.height()"
                          [showToolbar]="true"
                          [showSaveButton]="hasRoleSave()"
                          [showReadOnlyButton]="hasRoleDetail() && !(hasRoleSave())"
                          [showDelButton]="hasRoleDelete()"
                          [showTemplateButton]="hasRoleTemplate()"
                          [widthThreshold]="1000"
                          (selected)="onRoleSelected($event)"
                          (saveRolePermissionsClicked)="onSaveRolePermissionsClicked($event)">
          </app-roles-list>
        </div>

      </div>

      <div class="isg-role-cell">

        <div class="isg-subheader">
          <span>Menus/Display</span>
        </div>

        <div class="isg-role-pane" isgSizer #treeVisualPane="isgSizer">
          <app-auth-tree #authtreevisual
                         [moduleIds]="[currentModuleId]"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [heightControl]="treeVisualPane.height()"
                         [authTypes]="['M', 'V', 'PP']"
                         [active]="true"
                         [cascadeLink]="true"
                         [includeMembers]="false"
                         [includeHierarchies]="false"
                         [includeLabels]="true"
                         [showToolbar]="true"
                         [showSaveButton]="hasRoleSave()"
                         [showCreateButton]="hasPermCreate()"
                         [showEditButton]="hasPermEdit()"
                         [showReadOnlyButton]="hasPermDetail() && !(hasPermEdit())"
                         [showReorderButton]="hasPermReOrder()"
                         [showDeleteButton]="hasPermDelete()"
                         [enableSaveButton]="!!(currentRoleId)"
                         [widthThreshold]="1000">
          </app-auth-tree>
        </div>

      </div>

      <div class="isg-role-cell" [class.isg-cell-hide]="hideAuthDataTree">

        <div class="isg-subheader">
          <span>Data</span>
        </div>

        <div class="isg-role-pane" isgSizer #treeDataPane="isgSizer">
          <app-auth-tree #authtreedata
                         [moduleIds]="[currentModuleId]"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId"
                         [heightControl]="treeDataPane.height()"
                         [authTypes]="['D', 'PBI']"
                         [active]="true"
                         [cascadeLink]="true"
                         [includeMembers]="false"
                         [includeHierarchies]="false"
                         [includeLabels]="true"
                         [showToolbar]="true"
                         [showSaveButton]="hasRoleSave()"
                         [showCreateButton]="hasPermCreate()"
                         [showEditButton]="hasPermEdit()"
                         [showReadOnlyButton]="hasPermDetail() && !(hasPermEdit())"
                         [showReorderButton]="hasPermReOrder()"
                         [showDeleteButton]="hasPermDelete()"
                         [enableSaveButton]="!!(currentRoleId)"
                         [widthThreshold]="1000"
                         (dataLoaded)="onDataTreeLoaded($event)">
          </app-auth-tree>
        </div>

      </div>

      <div class="isg-role-cell">

        <div class="isg-subheader">
          <span>Role Users</span>
        </div>

        <div class="isg-role-pane" isgSizer #userPane="isgSizer">
          <app-user-list [moduleId]="currentModuleId"
                         [licenseId]="currentLicenseId"
                         [roleId]="currentRoleId ?? null"
                         [heightControl]="userPane.height()"
                         [showLicenseFilter]="true"
                         [widthThreshold]="1000">
          </app-user-list>
        </div>

      </div>

    </div>

  </div>

</div>
